// import external dependencies
import 'jquery';
import 'smoothscroll-for-websites';
import '@lottiefiles/lottie-player';
import 'slick-carousel/slick/slick.min.js';
import 'isotope-layout/dist/isotope.pkgd.min';
import 'fancybox/dist/js/jquery.fancybox.pack.js';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import blog from './routes/blog';
import category from './routes/category';
import aboutUs from './routes/about';
import templateSourceOfGrowth from './routes/sog';
import templateSmallestViableMarket from './routes/svm';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // blog page
  blog,
  // category page
  category,
  // template source of growth
  templateSourceOfGrowth,
  // template small viable market
  templateSmallestViableMarket,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js